const mainDomains = [
  'localhost',
  'getjusto.com',
  'bejusto.com',
  'local',
  'internal',
  'orioneat.com',
  'orioneats.com',
  ...(process.env.REACT_APP_DOMAIN ? [process.env.REACT_APP_DOMAIN] : [])
]

export default function getCurrentMainDomain() {
  return mainDomains.find(
    domain =>
      String(window.location.hostname) === domain ||
      String(window.location.hostname).endsWith(`.${domain}`)
  )
}
